import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';


//import EnteralGroup from './screens/enteral-group-list.vue';
const EnteralGroup = () => import('./screens/enteral-group-list.vue')

//import EnteralProduct from './screens/enteral-product-list.vue';
const EnteralProduct = () => import('./screens/enteral-product-list.vue')

const enteralRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.ENTERAL_VIEW,
    PERMISSIONS_KEYS.ENTERAL_INSERT,
    PERMISSIONS_KEYS.ENTERAL_EDIT,
  ])
) {
  enteralRoutes.push({
    path: '/enteral/grupos',
    name: 'Cadastro / Consulta|Grupo Produto Enteral',
    component: EnteralGroup,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
  enteralRoutes.push({
    path: '/enteral/produtos',
    name: 'Cadastro / Consulta|Produto Enteral',
    component: EnteralProduct,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { enteralRoutes };
